import React, { useState, useRef } from 'react';
import { useHistory } from "react-router-dom";
import {
    Box,
    Button,
    Typography,
    makeStyles,
    MenuItem,
    Select,
    Container,
    FormControl,
    Stepper,
    Step,
    StepLabel,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import CloseIcon from '@material-ui/icons/Close';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import UploadDetailsSavedDialog from '../../ModalPopups/UploadDetailsSavedDialog';
import axios from 'axios';
import { useApiBaseUrl } from '../../../../common/CommonMethods/CommonMethods';
import { appUrl } from '../../../../../../../utils/config';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    stepperHeader: {
        padding: "32px 0",
        textAlign: "center",
        backgroundColor: "#F5F9FF",
        position: "relative",
    },
    heading: {
        fontWeight: 600,
        fontSize: 38,
        lineHeight: "100%",
        marginBottom: 20,
    },
    subheading: {
        fontWeight: 400,
        fontSize: 24,
        lineHeight: "100%",
    },
    closePageAction: {
        position: "absolute",
        top: 20,
        right: 20,
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: "bold",
        color: "#000",
        "& svg": {
            marginLeft: 4,
            color: "red",
        },
    },
    uploadBox: {
        width: "100%",
        marginTop: "2em",
        border: "1px solid black",
        backgroundColor: "#f5f5f5",
        padding: "2em 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        minHeight: 60,
    },
    uploadText: {
        marginLeft: "auto",
        textAlign: "center",
        flex: 1,
        fontSize: 16,
    },
    uploadIcon: {
        fontSize: "40px",
        marginLeft: "auto",
        marginRight: "20px",
        color: "#333",
    },
    file: {
        marginTop: "2em",
        display: "flex",
        flexDirection: "column",
        gap: "1em",
        alignItems: "flex-start",
    },
    link: {
        color: "blue",
        textDecoration: "underline",
    },
    linkBox: {
        cursor: "pointer",
        display: "flex",
        gap: "0.5em",
    },
    bold: {
        fontWeight: 500,
    },
    criteria: {
        maxWidth: "500px",
    },
    uploadBtn: {
        backgroundColor: "#ec6535",
        color: "white",
        textTransform: "none",
        borderRadius: "50px",
        margin: "1em auto",
        padding: "5px 30px",
        "&:hover": {
            backgroundColor: "#ec6535",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#ec6535",
    },
    filePreview: {
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 8,
    },
    fileName: {
        color: "#2592f9",
        borderBottom: "2px solid #2592f9",
        paddingBottom: 2,
        cursor: "pointer",
    },
    fileSelect: {
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
        fontWeight: "bold"
    },
    uploadButton: {
        display: "flex",
        justifyContent: "center",
        margin: theme.spacing(4, 0),
    },
    uploadButtonStyle: {
        backgroundColor: '#ec6535',
        // width: "170px", // Removed fixed width
        color: '#fff',
        borderRadius: 20,
        padding: '6px 24px',
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        fontSize: "16px",
        gap: 8,
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: '#c6532b',
        },
    },
    validationSummary: {
        padding: "2em",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        margin: "2em 0",
    },
    summaryItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1em",
        margin: "0.5em 0",
        borderRadius: "4px",
        backgroundColor: "white",
    },
    validCount: {
        color: "#4caf50",
        fontWeight: "bold",
    },
    invalidCount: {
        color: "#f44336",
        fontWeight: "bold",
    },
    totalCount: {
        color: "#2196f3",
        fontWeight: "bold",
    },
    container: {
        textAlign: "center",
        padding: "1rem"
    },
    itemGrid: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    number: {
        fontSize: "2.4rem",
        fontWeight: 500
    },
    totalRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    validRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    invalidRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: theme.spacing(3),
        width: "100%",
    },
    reUploadButton: {
        marginRight: "auto",
        alignSelf: "flex-start",
        textDecoration: "underline",
        cursor: "pointer",
        textTransform: "none",
    },
}));

const getSteps = () => ["Upload file", "Validation summary"];

const transformValidRecordsForCorda = (validRecords, regionCode) => {
    return validRecords.map(record => ({
        productDetails: {
            facilityTypeName:record["Manufacturing Facility Type"] || "",
            drugTypeName:record["Product Modality"] || "",
            productTypeName:record["Product Type"] || "",
            productCode: record["BMS Product Code"] || "",
            productDescription: record["BMS Product Description"] || "",
            brand: record["Product Brand"] || "",
            status: record["Status"] || "Active",
            supplyTypeID: record["supplyTypeID"] || 0,
            facilityTypeID: record["facilityTypeID"] || 0,
            drugTypeID: record["drugTypeID"] || 0,
            vendorMosymphonyID: record["vendorMosymphonyID"] || 0,
            // pendingConfiguration: true,
            vendorPlant: record["vendorPlant"] || "",
            vendorName: record["vendorName"] || "",
            cmoProductCode: record["CMO Product Code"] || "",
            cmoProductDescription: record["CMO Product Description"] || "",
            cmoWIPProductCode: record["WIP Product"] || "",
            aslNumber: record["ASL Number"] || "",
            shipmentRequired: record["Shipment Required"],
            receivingStorageLocationIDsFromSponsorERP:record["BMS Product Receiving Storage Location IDs"] || "",
	        receivingPlantIDFromSponsorERP:record["BMS Product Receiving Plant IDs"] || "",
	        sponsorUOM:record["BMS UoM"] || "",
	        cmoUOM :record["CMO UoM"] || "",
            productTypeID:record["productTypeID"] || 0,
            regionCode: record["Region Code"] || "",
        },
        materialDetails: {
            productMaterialsList: record["BMS Material Code"] ? [{
                bo_material_code: record["BMS Material Code"] || "",
                material_description: record["BMS Material Description"] || "",
                cmo_material_code: record["CMO Material Code"] || "",
                cmo_material_description: record["CMO Material Description"] || "",
                material_type_id:record["materialTypeID"] || 0,
                bo_material_UOM: record["BMS Material UoM"] || "",
                cmo_material_UOM: record["CMO Material UoM"] || "",
                material_brand: record["Material Brand"] || "",
             materialStorageLocationIDsFromSponsorERP:record["BMS Material Storage Location IDs"] || "",
	          materialPlantIDFromSponsorERP:record["BMS Material Plant ID"] || "",
              sponsorSupplyingMaterial: record["BMS Supplying Material"].toLowerCase() === "yes" ? true : false,
        }] : []
        },
    processFlowConfiguration: {
        sponsorCQAApprovalReq: record["QA Check Required (Yes or No)"].toLowerCase() === "yes" ? true :false,
      },
    }));
};

const UploadProductDetails = () => {
    const history = useHistory();
    const classes = useStyles();
    const [file, setFile] = useState(null);
    const [fileType, setFileType] = useState('xlsx');
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [hasUploadedSuccessfully, setHasUploadedSuccessfully] = useState(false);
    const [uploadErrors, setUploadErrors] = useState([]);
    const [invalidRecords, setInvalidRecords] = useState([]);
    const [apiMessage, setApiMessage] = useState("");
    const [error, setError] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [validationData, setValidationData] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const fileInputRef = useRef();
    const API_BASE_URL = useApiBaseUrl(appUrl);
    const steps = getSteps();

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.name.endsWith('.xlsx')) {
            setFile(selectedFile);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
        } else {
            alert('Please upload a .xlsx file');
        }
        e.target.value = "";
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile && droppedFile.name.endsWith('.xlsx')) {
            setFile(droppedFile);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
        } else {
            alert('Please upload a .xlsx file');
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleRemoveFile = () => {
        if (isUploading) return;
        setFile(null);
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleUploadBoxClick = () => {
        if (!file || invalidRecords.length > 0 || uploadErrors.length > 0 || error) {
            fileInputRef.current.click();
        }
    };

    const getAcceptAttribute = (type) => {
        return ".xlsx, .xls";
    };

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
        setHasUploadedSuccessfully(false);
        setValidationData(null);
    };

    const handleUpload = async () => {
        if (file && !isUploading) {
            setIsUploading(true);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
            try {
                const formData = new FormData();
                formData.append('files', file);

                const response = await axios.post(`${API_BASE_URL}/uploadProductDetails`, formData);
                const data = response.data;

                setIsUploading(false);

                if (data.invalidRecords && data.invalidRecords.length > 0) {
                    setInvalidRecords(data.invalidRecords);
                    setApiMessage(data.message || "");
                    setUploadErrors([]);
                    setHasUploadedSuccessfully(false);
                    setUploadSuccess(false);
                    setValidationData({ ...data, regionCode: data.regionCode });
                    handleNext();
                } else if (data.status === false && (data.errorDescription)) {
                    setInvalidRecords([]);
                    setApiMessage("");
                    setUploadErrors([data.errorDescription].filter(Boolean));
                    setHasUploadedSuccessfully(false);
                    setUploadSuccess(false);
                }
                else {
                    setInvalidRecords([]);
                    setApiMessage("");
                    setHasUploadedSuccessfully(true);
                    // setUploadSuccess(true);
                    setValidationData({ ...data, regionCode: data.regionCode });
                    handleNext();
                }
            } catch (error) {
                setIsUploading(false);
                setInvalidRecords([]);
                setApiMessage("");
                if (error.response && error.response.data && ( error.response.data.errorDescription)) {
                    setUploadErrors([
                        error.response.data.errorDescription
                    ].filter(Boolean));
                } else {
                    setUploadErrors(['An error occurred while uploading. Please try again.']);
                }
            }
        }
    };

    const handleSubmitValidRecords = async () => {
        if (!validationData?.validRecords || isSubmitting) return;

        setIsSubmitting(true);
        try {
            const cordaRequest = {
                products: transformValidRecordsForCorda(validationData.validRecords, validationData.regionCode)
                
            };

            const response = await axios.post(`${API_BASE_URL}/productDetailsToCorda`, cordaRequest);

            if (response.data.status) {
                setUploadSuccess(true);
                setHasUploadedSuccessfully(true);
            } else {
                setError(response.data.errorDescription || "Submission failed.");
            }
        } catch (error) {
            const errMsg = error?.response?.data?.errorDescription ||
                "An error occurred during submission.";
            setError(errMsg);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCloseDialog = () => {
        setUploadSuccess(false);
        setFile(null);
        setFileType('xlsx');
        setIsUploading(false);
        setHasUploadedSuccessfully(false);
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
        setActiveStep(0);
        setValidationData(null);
        setIsSubmitting(false);
        history.push(`/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/products`)
    };

    const handleGoBack = () => {
        history.goBack()
    };

    const displayError = (
        <Container
            style={{
                width: "100%",
                border: "2px solid red",
                backgroundColor: "#ffeaea",
                padding: "0.8rem",
                marginBottom: "1.5em",
                textAlign: "center",
                fontSize: "0.875rem",
            }}
        >
            <Typography variant="body2">{error}</Typography>
        </Container>
    );

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Container>
                        {error && displayError}
                        {/* Show upload errors and invalid records below the upload button */}
                            {uploadErrors.length > 0 && (
                                <Box mt={2} style={{ width: '100%' }}>
                                    {uploadErrors.map((err, idx) => (
                                        <Container
                                            key={idx}
                                            style={{
                                                width: "100%",
                                                border: "2px solid red",
                                                backgroundColor: "#ffeaea",
                                                padding: "0.8rem",
                                                marginBottom: "0.5em",
                                                textAlign: "center",
                                                fontSize: "0.875rem",
                                            }}
                                        >
                                            <Typography variant="body2">{err}</Typography>
                                        </Container>
                                    ))}
                                </Box>
                            )}
                            {invalidRecords.length > 0 && (
                                <Box mt={2} style={{ width: '100%' }}>
                                    <Container
                                        style={{
                                            width: "100%",
                                            border: "2px solid red",
                                            backgroundColor: "#ffeaea",
                                            padding: "0.8rem",
                                            marginBottom: "0.5em",
                                            textAlign: "left",
                                            fontSize: "0.875rem",
                                        }}
                                    >
                                        <Typography variant="subtitle2">Rejected record(s) error(s):</Typography>
                                        {invalidRecords.map((records, recordIndex) => (
                                            <React.Fragment key={recordIndex}>
                                                {records.errors.map((error, errorIndex) => (
                                                    <Typography
                                                        key={`${recordIndex}-${errorIndex}`}
                                                        variant="body2"
                                                        gutterBottom
                                                        display="block"
                                                    >{`Row ${records?.row} - ${error}`}</Typography>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </Container>
                                </Box>
                            )}
                        <Box
                            className={classes.uploadBox}
                            onClick={handleUploadBoxClick}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            style={{
                                cursor: (!file || invalidRecords.length > 0 || uploadErrors.length > 0 || error) ? 'pointer' : 'not-allowed',
                                opacity: file && !(invalidRecords.length > 0 || uploadErrors.length > 0 || error) ? 0.6 : 1
                            }}
                        >
                            <input
                                type="file"
                                hidden
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                accept={getAcceptAttribute(fileType)}
                            />
                            <Typography className={classes.uploadText}>
                                Drag & drop file or click here to upload
                            </Typography>
                            <PublishIcon className={classes.uploadIcon} />
                        </Box>

                        <Box className={classes.file}>
                            <Typography>Select file type:</Typography>
                            <FormControl variant="outlined" size="small">
                                <Select
                                    value={fileType}
                                    onChange={(e) => setFileType(e.target.value)}
                                    disabled={file !== null && !(invalidRecords.length > 0 || uploadErrors.length > 0 || error)}
                                >
                                    <MenuItem value="xlsx">.xlsx</MenuItem>
                                </Select>
                            </FormControl>

                            {file && (
                                <Box className={classes.linkBox}>
                                    <Typography className={classes.link}>
                                        {file.name}
                                    </Typography>
                                    <span onClick={handleRemoveFile} style={{ cursor: "pointer" }}>
                                        ❌
                                    </span>
                                </Box>
                            )}

                            <Box>
                                <Typography className={classes.bold}>
                                    Validation criteria
                                </Typography>
                                <Typography className={classes.criteria}>
                                    Only excel files accepted (.xls, or .xlsx)
                                </Typography>
                                <Typography>First row must contain headers only</Typography>
                                <Typography>
                                    File should not contain blank rows or columns
                                </Typography>
                            </Box>

                            <Button
                                variant="contained"
                                className={classes.uploadBtn}
                                endIcon={<ChevronRightIcon />}
                                onClick={handleUpload}
                                disabled={!file || isUploading || hasUploadedSuccessfully || invalidRecords.length > 0}
                            >
                                {isUploading ? 'Uploading...' : 'Upload'}
                            </Button>

                            
                        </Box>
                    </Container>
                );
            case 1:
                return (
                    <Container className={classes.container}>
                        <Typography variant="h5" style={{ marginBottom: "1em" }}>
                            Validation Summary
                        </Typography>

                        {/* Summary of Records */}
                        <Grid container spacing={3} justify="space-between">
                            {[
                                {
                                    label: "Total Records",
                                    value: validationData?.validRecordsCount + validationData?.invalidRecordsCount || 0,
                                    className: classes.totalRecordsBox,
                                },
                                {
                                    label: "Valid Records",
                                    value: validationData?.validRecordsCount || 0,
                                    className: classes.validRecordsBox,
                                },
                                {
                                    label: "Rejected Records",
                                    value: validationData?.invalidRecordsCount || 0,
                                    className: classes.invalidRecordsBox,
                                },
                            ].map(({ label, value, className }, index) => (
                                <Grid item xs={12} sm={3} key={index}>
                                    <Box className={className}>
                                        <Typography>{label}</Typography>
                                        <Typography className={classes.number}>{value}</Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>

                        {/* Rejected Records */}
                        {invalidRecords.length > 0 && (
                            <Grid item xs={12}>
                                <Box width="100%" style={{ margin: "1em 0" }}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography variant="subtitle2">Rejected record(s) error(s)</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flexStart",
                                                textAlign: "left",
                                            }}
                                        >
                                            {invalidRecords.map((records, recordIndex) => (
                                                <React.Fragment key={recordIndex}>
                                                    {records.errors.map((error, errorIndex) => (
                                                        <Typography
                                                            key={`${recordIndex}-${errorIndex}`}
                                                            variant="body1"
                                                            gutterBottom
                                                            display="block"
                                                        >{`Row ${records?.row} - ${error}`}</Typography>
                                                    ))}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </Grid>
                        )}

                        <Box className={classes.buttonContainer}>
                            <Button className={classes.reUploadButton} onClick={handleBack}>
                                &lt; Re-upload File
                            </Button>
                            <Box style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    className={classes.uploadButtonStyle}
                                    onClick={handleSubmitValidRecords}
                                    disabled={isSubmitting || (validationData?.validRecordsCount || 0) === 0}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit Records'}
                                    <ChevronRightIcon />
                                </Button>
                            </Box>
                        </Box>
                    </Container>
                );
            default:
                return <Typography>Unknown Step</Typography>;
        }
    };

    return (
        <Box className={classes.root}>
            <Box className={classes.stepperHeader}>
                <Typography className={classes.heading}>
                    Upload Product Details
                </Typography>
                <Typography className={classes.subheading}>
                    Add / Update the list of products through the file
                </Typography>
                <Box className={classes.closePageAction} onClick={handleGoBack}>
                    <Typography style={{ fontWeight: 'bold', fontSize: "18px" }}>Cancel</Typography>
                    <CloseIcon />
                </Box>
            </Box>

            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {getStepContent(activeStep)}

            {/* Success Dialog */}
            <UploadDetailsSavedDialog
                open={uploadSuccess}
                onClose={handleCloseDialog}
            />


        </Box>
    );
};

export default UploadProductDetails;